import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';

const LINK = process.env.REACT_APP_VIMEO_VIDEO_LINK;


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


export default function WatchVideoButton() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Watch Video
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} width="xl">
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          AgencyIQ Intro Video
        </DialogTitle>
        <DialogContent dividers>
        <Container maxWidth="xl" style={{ width: "550px"}}>
          <div style={{ padding: "53.75% 0 0 0", position: "relative", width: "100%" }}>
            <iframe
              src={LINK}
              frameBorder="0"
              allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media;"
              referrerPolicy="strict-origin-when-cross-origin"
              loading="lazy"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              title="AgencyIQ - Demo"
            ></iframe>
          </div>
        </Container>
        </DialogContent>
      </Dialog>
    </div>
  );
}
